export default __webpack_public_path__ + "static/media/thirteen_.c7d6a49b.jpeg";